import type { GetRolesParams } from '@vlabs/api/artemy/model';
import { createGenericFiltersContext } from '@vlabs/monokit/shared/lib';

const [
  useRoleListFilters,
  RoleListFiltersProvider,
] = createGenericFiltersContext<GetRolesParams>({
  displayName: 'RoleListFilters',
});

export {
  useRoleListFilters,
  RoleListFiltersProvider,
};
